export class RequestDeliveryInfo {
  public isFlightArrived?: boolean;
  public RequestId?: number;
  public AttentionName?: string;
  public AttentionPhone?: string;
  public ConsigneeName?: string;
  public ConsigneeAddress?: string;
  public Email?: string;
  public ShippingAddress?: string;
}
